"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const LogoutExternal = () => {
    var _a, _b, _c, _d;
    const location = (0, react_router_dom_1.useLocation)();
    let redirectUrl = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.redirectUrl;
    let errorMessage = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.errorMessage;
    if (!redirectUrl) {
        redirectUrl = (_c = new URL(window.location.href).searchParams.get('redirectUrl')) !== null && _c !== void 0 ? _c : '/';
    }
    if (!errorMessage) {
        errorMessage = (_d = new URL(window.location.href).searchParams.get('errorMessage')) !== null && _d !== void 0 ? _d : '';
    }
    const redirect = (e, url) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        const fullPath = url.startsWith('/') ? url : `/${url}`;
        window.location.href = fullPath !== null && fullPath !== void 0 ? fullPath : '/';
    };
    (0, react_1.useEffect)(() => {
        if (!errorMessage) {
            redirect(undefined, redirectUrl);
        }
    }, [errorMessage, redirectUrl]);
    return (errorMessage && ((0, jsx_runtime_1.jsx)("div", { id: "login-view", children: (0, jsx_runtime_1.jsx)("div", { className: "login-container", children: (0, jsx_runtime_1.jsxs)("div", { style: { textAlign: 'center' }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "alert alert-danger", children: [`${__.trans(errorMessage)}`, (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), redirectUrl.includes('1177.se')
                                ? __.trans('user.back-to-login-1177-info')
                                : __.trans('user.back-to-login-info')] }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: redirectUrl, className: "btn theme-button-primary", onClick: (e) => redirect(e, redirectUrl), children: redirectUrl.includes('1177.se')
                            ? __.trans('user.back-to-login-1177')
                            : __.trans('user.back-to-login') })] }) }) })));
};
exports.default = LogoutExternal;
